import pagesLaborCoreAnchorDateEn from "./anchor-date/default";
import pagesLaborCoreInstanceEn from "./instance/default";
import pagesLaborCoreOperationPackagesEn from "./operation-packages/default";
import pagesLaborCoreSelectTargetsEn from "./select-targets/default";
import pagesLaborCoreSettingsEn from "./settings/default";

export default {
  operationPackages: pagesLaborCoreOperationPackagesEn,
  instance: pagesLaborCoreInstanceEn,
  settings: pagesLaborCoreSettingsEn,
  selectTargets: pagesLaborCoreSelectTargetsEn,
  anchorDate: pagesLaborCoreAnchorDateEn,
};
